
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { toast } from '@/components/ui/use-toast';

interface ResumeAnalysisTabProps {
  onSubmit: (text: string, type: 'resume') => void;
}

const ResumeAnalysisTab: React.FC<ResumeAnalysisTabProps> = ({ onSubmit }) => {
  const [resumeText, setResumeText] = useState('');

  const handleSubmit = () => {
    if (resumeText.trim()) {
      onSubmit(resumeText, 'resume');
      setResumeText('');
    } else {
      toast({
        title: "Empty Resume",
        description: "Please paste your resume text before submitting.",
        variant: "destructive"
      });
    }
  };

  return (
    <div className="space-y-3 h-full flex flex-col pt-0">
      <h3 className="text-lg font-medium">Resume Analysis</h3>
      <p className="text-sm text-muted-foreground">
        Paste your resume text below for personalized feedback, skills gap analysis, and career path recommendations.
      </p>
      <Textarea 
        className="flex-1 min-h-[200px]"
        placeholder="Paste your resume text here..."
        value={resumeText}
        onChange={(e) => setResumeText(e.target.value)}
      />
      <Button onClick={handleSubmit} className="ml-auto">
        Analyze Resume
      </Button>
    </div>
  );
};

export default ResumeAnalysisTab;
